<template>
  <div class="w-full min-h-4 bg-gray-200 rounded-full" v-bind="$attrs">
    <div
      class="min-h-4 rounded-full transition-width duration-1000 ease-in-out"
      :class="`bg-${variant}`"
      :style="{ width: `${progress < 0 ? 0 : progress > 100 ? 100 : progress}%` }"
    />
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

defineProps({
  progress: {
    type: Number,
    default: 0
  },
  variant: {
    type: String as PropType<'primary' | 'success' | 'warning' | 'danger'>,
    default: 'primary'
  }
})
</script>
